import React from "react";
//#region types
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { SelectionChipsProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import SelectionGroup from "../../selection/selectionGroup";
import { Grid } from "@mui/material";
//#endregion

function SelectionChips(props: SelectionChipsProps) {
  const { value, setValue, items, hideOthersOnSelection, disabledItems, disabled, endAdornment } = props;

  const onChangeHandler = (selectedItem?: SelectionItem) => {
    setValue(selectedItem?.id);
    setTimeout(() => {
      props.onBlur && props.onBlur({ target: { name: props.name } } as React.FocusEvent<HTMLInputElement>);
    });
  };

  const selectedItem = items?.find((x) => x.id === value);

  return (
    <Grid
      item
      container
      wrap="nowrap"
      alignItems="center"
      direction="row"
      columnGap={0.5}
      data-testid={`${props.name}SelectionChips`}
    >
      <Grid item>
        <SelectionGroup
          items={items}
          value={selectedItem ? [selectedItem] : []}
          onChange={(item) => onChangeHandler(item[0])}
          disabled={disabled}
          hideOthersOnSelection={hideOthersOnSelection}
          hideViewAll
          disabledItems={disabledItems}
        />
      </Grid>
      {endAdornment && <Grid item>{endAdornment}</Grid>}
    </Grid>
  );
}

export default SelectionChips;
